module.exports = __webpack_public_path__ + "style/img/建筑可视化管理系统.9723b277.jpg";